export const getPlans = (state, props) => {
  if (props?.plans) {
    return props.plans;
  }
  if (state?.data?.plan?.items) {
    return state.data.plan.items;
  }
  return new Map();
};
